<template>
  <div class="projects-info-list item-list item-report-summary lead-info-table">
    <div class="summary-toolbar">
      <h2>campaign Leads</h2>
    </div>

    <table v-if="leadInfo">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Date</th>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>C.I</th>
          <th>C.M</th>
          <th>Addressed</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(info, index) in leadInfo" :key="info.key">
          <td>
            {{ index + 1 }}
          </td>
          <td>
            {{ info.date ? new Date(info.date * 1000).toLocaleDateString('en-GB') : 'N/A' }}
          </td>
          <td>
             {{info.name}}
          </td>
          <td>
            {{info.email}}
          </td>
          <td>
            {{info.phone}}
          </td>
          <td>
            {{info.campaign_id}}
          </td>
          <td>
            {{info.campaign_source}}
          </td>
          <td>
            <input title="addressed checkbox" class='addressed-checkbox' type='checkbox' :checked='info.addressed'
              @change='handleAddressedChange(info, $event)' />
          </td>
          <td class="notes-cell">
            <div class="notes-display">
              <span
                :title="info.notes"
              >
                {{ info.notes ? info.notes.slice(0, 100) + (info.notes.length > 100 ? '...' : '') : 'N/A' }}
              </span>
              <svg class="edit-icon" @click="startEdit(info)">
                <title>Edit Notes</title>
                <use xlink:href='#edit-icon' />
              </svg>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showConfirmDialog" class="confirm-overlay">
      <div class="confirm-dialog">
        <div class="confirm-header">
          <h3>Confirm Action</h3>
        </div>
        <div class="confirm-body">
          <p>{{ confirmMessage }}</p>
        </div>
        <div class="confirm-footer">
          <button  title="cancel Update" class="btn-cancel" @click="cancelUpdate">Cancel</button>
          <button title="confirm Update" class="btn-confirm" @click="confirmUpdate">Confirm</button>
        </div>
      </div>
    </div>
    <!-- Notes Editor Dialog -->
    <div v-if="showNotesDialog" class="confirm-overlay">
      <div class="notes-dialog">
        <div class="confirm-header">
          <h3>Edit Notes</h3>
        </div>
        <div class="confirm-body">
          <textarea v-model="draftNotes" placeholder="Enter notes here..." rows="5"></textarea>
        </div>
        <div class="confirm-footer">
          <button title="cancel Edit" class="btn-cancel" @click="cancelEdit">Cancel</button>
          <button  title="save Notes" class="btn-confirm" @click="saveNotes">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue';
import { ProjectList } from '@/store/modules/admin';

export default {
  props: {
    leadInfo: Array,
    response: Object,
    title: {
      type: String,
      default: '',
    },
    total: {
      type: String,
      default: '',
    },
  },
  emits: ['update-lead'],
  setup(props, { emit }) {
    const showConfirmDialog = ref(false);
    const confirmMessage = ref('');
    const isUpdating = ref(false);

    const pendingUpdate = ref(null);
    const pendingEvent = ref(null);

    const editingInfo = ref(null);
    const draftNotes = ref('');
    const showNotesDialog = ref(false);

    const updateLead = async (info, updateType, newValue) => {
      if (isUpdating.value) return;

      isUpdating.value = true;

      try {
        const updatedData = {
          ...info,
          [updateType]: newValue,
        };

        await ProjectList.updateCampaignLead(info.key, updatedData);
        info[updateType] = newValue;
        emit('update-lead');
      } catch (err) {
        // console.error('Failed to update lead:', err);
        if (updateType === 'addressed' && pendingEvent.value) {
          pendingEvent.value.target.checked = !newValue;
        }
      } finally {
        isUpdating.value = false;
        if (updateType === 'addressed') {
          showConfirmDialog.value = false;
        }
        if (updateType === 'notes') {
          showNotesDialog.value = false;
          editingInfo.value = null;
          draftNotes.value = '';
        }
      }
    };

    const handleAddressedChange = (info, event) => {
      pendingUpdate.value = { info, type: 'addressed', value: event.target.checked };
      pendingEvent.value = event;
      confirmMessage.value = `Mark lead '${info.name}' as ${event.target.checked ? 'addressed' : 'not addressed'}?`;
      showConfirmDialog.value = true;
    };

    const confirmUpdate = async () => {
      if (pendingUpdate.value) {
        await updateLead(
          pendingUpdate.value.info,
          pendingUpdate.value.type,
          pendingUpdate.value.value,
        );
        pendingEvent.value = null;
        pendingUpdate.value = null;
      }
    };

    const cancelUpdate = () => {
      if (pendingEvent.value) {
        pendingEvent.value.target.checked = !pendingEvent.value.target.checked;
      }
      showConfirmDialog.value = false;
      pendingEvent.value = null;
      pendingUpdate.value = null;
    };

    const startEdit = (info) => {
      editingInfo.value = info;
      draftNotes.value = info.notes || '';
      showNotesDialog.value = true;
    };

    const cancelEdit = () => {
      showNotesDialog.value = false;
      editingInfo.value = null;
      draftNotes.value = '';
    };

    const saveNotes = async () => {
      if (editingInfo.value) {
        await updateLead(editingInfo.value, 'notes', draftNotes.value);
      }
    };

    return {
      handleAddressedChange,
      confirmUpdate,
      cancelUpdate,
      showConfirmDialog,
      confirmMessage,

      draftNotes,
      startEdit,
      cancelEdit,
      saveNotes,
      showNotesDialog,
      editingInfo,
    };
  },
};
</script>
<style lang="scss" scoped>
.lead-info-table {
  width: 100%;

  &.item-report-summary {
    table {
      thead {
        th {
          p {
            padding: 0;
            text-align: center;
            font-size: size(16);
            &.currency {
              padding: size(15) 0 0;
              text-align: center;
              font-size: size(12);
            }
          }
        }
      }
      tbody {
        tr {
          td {
            &:nth-child(2), &:nth-child(3) {
              word-break: break-all;
              line-height: size(20);
            }
            span {
              vertical-align: top;
            }
          }
          &:hover {
            background: var(--admin--color-level1);
          }
        }
      }
    }
  }
}
.admin-container .admin-screen-content .item-list table tr td {
    border-bottom: none;
}
.addressed-checkbox {
  width: size(20);
  height: size(20);
  cursor: pointer;
  display: block;
  margin: 0 auto;
}

.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.confirm-dialog {
  background-color: var(--admin--color-level4);
  border: size(1) solid var(--admin--text-level2);
  border-radius: size(4);
  max-width: size(400);
  width: 90%;
  padding: size(20);
}

.confirm-header {
  margin-bottom: size(15);

  h3 {
    margin: 0;
    color: #d4d4ff;
    font-size: size(20);
  }
}

.confirm-footer {
  display: flex;
  justify-content: flex-end;
  gap: size(10);

  button {
    padding: size(8) size(16);
    border: none;
    border-radius: size(4);
    font-size: size(18);
    cursor: pointer;
  }

  .btn-cancel {
    background-color: grey;
    color: #fff;
  }

  .btn-confirm {
    background-color: var(--admin--color-level3);
    color: #fff;
  }
}

.edit-icon {
  width: size(16);
  height: size(16);
  display: block;
  margin: 0 auto;
  cursor: pointer;
  fill: #fff;
}
.notes-cell {
  .notes-display {
    display: flex;
    gap: size(8);
    span {
      flex: 1;
    }
  }
}

.notes-dialog {
  background-color: var(--admin--color-level4);
  border: size(1) solid var(--admin--text-level2);
  border-radius: size(4);
  max-width: size(500);
  width: 90%;
  padding: size(20);
}
.confirm-body {
  margin-bottom: size(20);

  p {
    font-size: size(18) !important;
    padding: 0 !important;
  }

  textarea {
    width: 100%;
    padding: size(10);
    border-radius: size(4);
    border-bottom: size(1) solid var(--admin--text-level2);
    background-color: var(--admin--color-level4);
    color: #fff;
    font-size: size(18);
    min-height: size(200);

    &::placeholder {
      color: #666;
    }
  }
}
</style>
